import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  Role: {content: <Skeleton width="160px" />, center: false},
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const AdminRoleSkeleton = () => {
  return <DynamicSkeleton rows={6} columnConfig={columnConfig} />
}

export default AdminRoleSkeleton
